import { redirect } from '@tanstack/react-router';

export type CombinedTabBeforeLoadArgs = {
  context: {
    flags: {
      enableCombinedPortfolioAndVisualizationsTab: boolean;
    };
  };
  params: {
    loopId: number;
    org: string;
  };
};

export const mergedPortfolioViewBeforeLoad = ({ context, params }: CombinedTabBeforeLoadArgs) => {
  if (!context.flags.enableCombinedPortfolioAndVisualizationsTab) {
    throw redirect({
      to: '/org/$org/loop/$loopId/portfolio',
      params,
      search: true,
      replace: true,
    });
  }
};
